import { render, staticRenderFns } from "./SystemBackup.vue?vue&type=template&id=7c61ffcd&scoped=true"
import script from "./SystemBackup.vue?vue&type=script&lang=js"
export * from "./SystemBackup.vue?vue&type=script&lang=js"
import style0 from "./SystemBackup.vue?vue&type=style&index=0&id=7c61ffcd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c61ffcd",
  null
  
)

export default component.exports